(function(){
  function init(){
    var wrap=document.querySelector('[data-lv-swatches]');
    if(!wrap)return;
    wrap.querySelectorAll('.lv-swatch').forEach(function(sw){
      sw.addEventListener('click',function(){
        if(sw.dataset.avail==='false')return;
        wrap.querySelectorAll('.lv-swatch').forEach(function(b){b.classList.remove('active')});
        sw.classList.add('active');
        var id=sw.dataset.id.split('/').pop();
        document.querySelectorAll('form.lv-atc-form input[name=id]').forEach(function(i){i.value=id;});
        var price=sw.dataset.price;
        document.querySelectorAll('.lv-buy__price strong, .lv-sticky__price strong').forEach(function(el){el.textContent=price;});
        document.querySelectorAll('form.lv-atc-form button[type=submit]').forEach(function(b){
          if(b.textContent.indexOf('—')>-1){b.textContent=b.textContent.split('—')[0].trim()+' — '+price;}
        });
        if(sw.dataset.image){var main=document.querySelector('.lv-buy__main img');if(main){main.src=sw.dataset.image;}}
        try{var u=new URL(window.location);u.searchParams.set('variant',id);history.replaceState({},'',u);}catch(e){}
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();